export default __webpack_public_path__ + "static/kim-dental-logo-1e5631042119ee67f2235d1d1cf15fcd.png";